<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div id="skill-bg" class="player"></div>
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>정령탄 / 마정탄</h2>
                    <p>무기 그레이드에 따라 변화하는 -  똑똑한 정탄 시스템</p>
                    <p>- 그레이드별 정탄 구비는 이제 그만, 통합 된 정탄 하나로 모든 무기에 사용 가능 –</p>
                    <p>하나로 통합 된 정령탄/마정탄 장착 시, 장착한 무기의 그레이드에 따라 이펙트와 효과가 변화되고 타격 시 발동 된다.</p>
                </div>
                <div id="skill-video-1" class="player" style="width:890px;height:500px;position:absolute;top:455px;left:50%;margin-left:-445px; z-index:6;"></div>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';
    import YoutubePlayer from "promokit-youtubeplayer";

    export default {
        name: "skill",
        mixins: [BasePage],
        data() {
            return {
                name: "skill",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg_8.jpg", objName: "bg"}
                ]
            };
        },
        methods: {
            canvasSet() {
                this.bgPlayer = new nc.promokit.Player({
                    selector: '#skill-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/bg_8.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer.pause();
                TweenMax.set(this.$el.querySelector('#skill-bg'), {autoAlpha:0});

                this.baseCavasSet(this.contentData);


                this.cvObj.txtTitleCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleCon);
                this.cvObj.txtTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_8_tit.png');
                canvasObjPosition(this.cvObj.txtTitle, this.cvObj.txtTitleCon, this.contentSize.w/2, 210);

                this.cvObj.txt1Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt1Con);
                this.cvObj.txt1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_8_txt_1.png');
                canvasObjPosition(this.cvObj.txt1, this.cvObj.txt1Con, this.contentSize.w/2, 298);

                this.cvObj.txt2Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt2Con);
                this.cvObj.txt2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_8_txt_2.png');
                canvasObjPosition(this.cvObj.txt2, this.cvObj.txt2Con, this.contentSize.w/2, 384);

                this.cvObj.txt3Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt3Con);
                this.cvObj.txt3 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_8_txt_3.png');
                canvasObjPosition(this.cvObj.txt3, this.cvObj.txt3Con, this.contentSize.w/2, 411);
            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.txtTitleCon, 1.3, {pixi: { brightness: 3}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txt1, 0.7, {pixi: { alpha: 0, scale:1.2}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.5')
                    .fromTo(this.cvObj.txt2, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt2Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt3, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1.3')
                    .fromTo(this.cvObj.txt3Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1.3')
                    .fromTo(this.$el.querySelector("#skill-video-1"), 0.7,{y:50, autoAlpha:0},  {y:0, autoAlpha:1, ease:Power2.easeOut}, 'bgMotionEnd+=1.5')
                    .call(()=>{
                        this.bgPlayer.seek(1);
                        this.bgPlayer.play();
                        TweenMax.set(this.$el.querySelector('#skill-bg'), {autoAlpha:1})
                    }, null, null, 'bgMotionEnd+=0')
                    .to(this.cvObj.bg, 0.7, {pixi: { alpha: 0}, delay:0.2 }, 'bgMotionEnd+=0');


                this.enterMotion.play();
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);


                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        },
        mounted() {
            let videoRanking = new nc.promokit.Player({
                selector: "#skill-video-1",
                videoId: "https://vod.plaync.com/lineage2/old/190220_jinkamael/bullet.mp4",
                mute: true,
                controls: false,
                coverClick: false,
                loop: true,
                autoPlay:false
            });
            TweenMax.delayedCall(2.5, ()=>{videoRanking.play();})
        }
    };
</script>

